<script setup lang="ts">
import {
  backdropOpacity,
  inputValue,
  isMaskDrawerClosed,
  isShowedUpselling,
} from '@/refs/product.refs';
import { formatPrice } from '@/utils/formatPrice';
import buttonProductPrevSim from './buttonProductPrevSim.vue';

const props = defineProps({
  cat: {
    type: Object,
    required: false,
  },
  position: {
    type: Number,
  },
});

const emit = defineEmits(['handleToogleDrawer']);

const HandleToogleDrawer = () => {
  inputValue.value = null;
  isMaskDrawerClosed.value = true;
  backdropOpacity.value = 0.2;
  emit('handleToogleDrawer');
};
</script>
<template>
  <Transition
    appear
    mode="out-in"
    enter-active-class="transition-all duration-500 ease-out"
    enter-from-class="translate-y-8 opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-8 opacity-0"
  >
    <section
      class="relative"
      :class="isShowedUpselling ? 'left-0 w-full' : 'left-[15px] w-[150px]'"
    >
      <article
        class="relative flex flex-col items-center justify-center gap-2 p-0"
        role="listitem"
        @click="HandleToogleDrawer"
      >
        <div
          class="bg-soft-gray flex h-[117px] flex-row items-center justify-center rounded-[10px]"
          :class="isShowedUpselling ? 'max-w-full' : 'w-[135px]'"
        >
          <buttonProductPrevSim />

          <div
            class="flex h-[102px] items-center justify-center"
            :class="isShowedUpselling ? 'max-w-full' : 'w-20'"
          >
            <img
              v-show="cat?.image !== null"
              :src="cat?.image === null ? '' : cat?.image?.info.url"
              :alt="cat?.image?.designation"
              class="h-full w-full object-contain"
              :title="cat?.image?.designation"
            />
          </div>
        </div>

        <div
          class="!m-0 flex w-[126px] flex-col items-start gap-[4px] p-0"
          :class="isShowedUpselling ? 'self-start' : 'self-center'"
        >
          <p
            class="text-12px font-tt-semiBold-Normal text-grand-text line-clamp-2 max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
          >
            {{ cat?.designation }}
          </p>

          <p
            class="text-12px text-grand-text font-tt-medium-Normal overflow-hidden text-ellipsis whitespace-nowrap"
          >
            {{ formatPrice(Number(cat?.price)) }}
          </p>
        </div>
      </article>

      <p
        v-show="isShowedUpselling"
        class="text-littleSize text-text-newSelect !m-0 font-medium"
        :class="
          position !== undefined && position % 2 === 0 ? 'block' : 'hidden'
        "
      >
        1 Acheté = 1 Offert
      </p>
    </section>
  </Transition>
</template>
